module.exports = __webpack_public_path__ + "media/images/icons/search-993ce0a0e769ad59a8758fb4cd19905d.svg";